import React from "react";
import PropTypes from "prop-types";

import cuid from "cuid";
import Icon from "../Icons";
import Label from "./Label";
import Note from "./Note";
import ValidationError from "./ValidationError";

export const Textarea = ({
  input,
  label,
  helper,
  meta: { error, touched } = {},
  id = cuid(),
  disabled,
  ...rest
}) => (
  <>
    {label && <Label value={label} target={id} />}

    <div className="relative">
      <textarea
        id={id}
        {...input}
        {...rest}
        disabled={disabled}
        className={`shadow-inner appearance-none border rounded w-full h-full py-2 px-4 
        text-grey-darker text-14 border-grey ${
          error && touched ? "border-red" : "border-grey"
        } ${disabled ? "pl-8" : ""}`}
      />

      {disabled && (
        <div className="absolute top-0 mt-2 ml-2 text-grey-darker-1">
          <Icon name="Lock" />
        </div>
      )}
    </div>
    {helper && <Note value={helper} />}
    {error && touched && <ValidationError value={error} />}
  </>
);

Textarea.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string
  })
};
